import { useState } from "react";
import { Button, message, Tooltip } from "antd";
import { PlusOutlined } from "@ant-design/icons";
import { ModalPortal } from "../../../../../common/components/modalPortal/modalPortal";
import { RecruiterGoals } from "../../../../../redux/models/recruiterGoals";
import { CreateGoalsModal } from "./createGoalsModal";

export const CreateGoalsButton = ({ clients, onSuccess, disabled = false }) => {
  const [loading, setLoading] = useState(false);

  const availableClients = clients.map((c) => ({ label: c.name, value: c.id }));

  const tooltipTitle = !availableClients.length
    ? "No available clients to add goals."
    : "";

  const onFinish = (closeModal) => async (values) => {
    try {
      setLoading(true);
      const res = await RecruiterGoals.create(values, false);

      onSuccess(res.data);
      closeModal();
      message.success("Recruiter goals successfully created");
    } catch (e) {
      message.error(e.message);
      console.error(e);
    } finally {
      setLoading(false);
    }
  };

  return (
    <ModalPortal
      renderTrigger={(triggerProps) => (
        <Tooltip title={tooltipTitle} placement="left">
          <span>
            <Button
              type="primary"
              icon={<PlusOutlined style={{ fontSize: "0.8em" }} />}
              disabled={loading || disabled}
              {...triggerProps}
            >
              Create Goals
            </Button>
          </span>
        </Tooltip>
      )}
    >
      {({ open, closeModal }) => (
        <CreateGoalsModal
          open={open}
          loading={loading}
          onFinish={onFinish(closeModal)}
          availableClients={availableClients}
          closeModal={closeModal}
        />
      )}
    </ModalPortal>
  );
};
